export const COMPANY_NAME = 'INNOVATE AI PTE. LTD.'
